<span class="material-symbols-rounded notranslate" [style.font-size.px]="size">
  <ng-content></ng-content>
</span>
